import { formatCurrency } from "../../utils/format";

const SummaryCards = ({ summaryData }) => {
  const labels = {
    budget: "Total Budget",
    burn: "Work in Progress",
    revenue: "Invoice Summary",
  };
  const icons = {
    budget: <i className="bi bi-coin text-primary" />,
    burn: <i className="bi bi-fire text-warning" />,
    revenue: <i className="bi bi-file-bar-graph-fill text-success" />,
  };

  return (
    <div className="row">
      {summaryData &&
        Object.keys(summaryData).map((key) => (
          <div className="col-md-3 mb-3">
            <div className="card summary-card">
              <div className="card-body">
                <h6 className="card-title">
                  {icons[key]} {labels[key]}
                </h6>
                <p className="card-text">
                  {formatCurrency(summaryData[key]?.total)}
                </p>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default SummaryCards;
